import * as React from 'react';
import { useCallback } from 'react';
import { useRange } from 'react-instantsearch';
import { ButtonDropdown, Price } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import { useFacetLabel } from '../../hooks/use-facet-label.js';
import { ClearFacetFilter } from '../ClearFacetFilter/ClearFacetFilter.js';
import FacetContainer from '../FacetContainer/FacetContainer.js';
import FacetInputPriceRange from './FacetInputPriceRange.js';

const roundPrice = (value)=>{
    return Math.round(value / 100);
};
function ConnectedFacetInputPriceRange({ facet  }) {
    const { range: { max , min  } , start , refine ,  } = useRange({
        attribute: facet.attribute
    });
    const label = useFacetLabel({
        facet
    });
    const clear = useCallback(()=>refine([
            min,
            max
        ])
    , [
        refine,
        min,
        max
    ]);
    const intl = useIntl();
    const handleOnChange = React.useCallback((value)=>{
        refine([
            value.min,
            value.max
        ]);
    }, [
        refine
    ]);
    if (!isNumber(min) || !isNumber(max) || max === min) {
        return null;
    }
    const currentRefinement = {
        min: Math.max(min, Number.isFinite(start[0]) ? start[0] : min),
        max: Math.min(max, Number.isFinite(start[1]) ? start[1] : max)
    };
    const clearButtonEnabled = currentRefinement.min !== min || currentRefinement.max !== max;
    const ariaLabel = `${intl.getLabel('search.filterBy')} ${label.toLowerCase()}`;
    return /*#__PURE__*/ React.createElement("div", {
        className: "connected-facet-input-range"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown, {
        focusItemOnHover: false,
        loop: true,
        "aria-label": ariaLabel,
        "data-t": "connected-facet-input-range-button"
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.Button, {
        className: "connected-facet-input-range__button"
    }, label), /*#__PURE__*/ React.createElement(ButtonDropdown.Content, {
        type: "generic",
        restoreFocus: true
    }, /*#__PURE__*/ React.createElement(FacetContainer, {
        ClearButton: /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
            isDisabled: !clearButtonEnabled,
            childElement: "button"
        }, /*#__PURE__*/ React.createElement(ClearFacetFilter, {
            onClear: clear,
            isDisabled: !clearButtonEnabled,
            label: intl.getLabel('search.filters.clear', {
                defaultValue: 'clear'
            })
        })),
        title: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Price, {
            value: roundPrice(currentRefinement.min),
            currency: intl.currency,
            centAmount: false
        }), ' – ', /*#__PURE__*/ React.createElement(Price, {
            value: roundPrice(currentRefinement.max),
            currency: intl.currency,
            centAmount: false
        }))
    }, /*#__PURE__*/ React.createElement(ButtonDropdown.InteractiveWrapper, {
        childElement: "slider"
    }, /*#__PURE__*/ React.createElement(FacetInputPriceRange, {
        min: min,
        max: max,
        value: currentRefinement,
        facetLabel: label,
        onChange: handleOnChange,
        renderNumber: roundPrice
    }))))));
}

export { ConnectedFacetInputPriceRange };
//# sourceMappingURL=ConnectedFacetInputPriceRange.js.map
